import type Unit from '~/types/unit'
import type Filter from '~/types/filter'

const MAX_NUMBER_OF_ITEMS_FOR_TOGGLE_BUTTONS = 7
const FIELDS_THAT_CAN_USE_TOGGLE_BUTTONS = ['rooms', 'floor']
const displayToggleButtons = (filter: Filter) => {
    if (
        filter.field.isSystem === true &&
        FIELDS_THAT_CAN_USE_TOGGLE_BUTTONS.includes(filter.field.key) &&
        filter.allValues.length <= MAX_NUMBER_OF_ITEMS_FOR_TOGGLE_BUTTONS
    )
        return true
}

export const filterFunction = (unit: Unit, filter: Filter): boolean => {
    switch (filter.field.type) {
        case 'number':
        case 'currency':
        case 'area': {
            if (displayToggleButtons(filter)) {
                return filterFunctionId(unit, filter)
            }

            return filterFunctionNumber(unit, filter)
        }
        case 'string':
        case 'html':
        case 'url': {
            return filterFunctionString(unit, filter)
        }
        case 'id':
        case 'status':
        case 'building': {
            return filterFunctionId(unit, filter)
        }
        case 'date': {
            return filterFunctionDate(unit, filter)
        }
        case 'boolean': {
            return filterFunctionBoolean(unit, filter)
        }
        default: {
            return false
        }
    }
}

const conditionsInUrlToArray = (value) => {
    if (typeof value === 'string') {
        return [value]
    }
    return value
}

const filterFunctionBoolean = (unit: Unit, filter: Filter): boolean => {
    const key = filter.field.key
    let conditions = conditionsInUrlToArray(filter.conditionsInUrl)

    const flattenedUnit = { ...unit, ...unit.rowData, ...unit.customColumnValues }

    let fieldValueForUnit = flattenedUnit[key]

    for (const condition of conditions) {
        // If its not true its false 😂
        if (condition === 'false' && fieldValueForUnit === null) return true
        if (`${fieldValueForUnit}` === condition) return true
    }

    return false
}

const filterFunctionNumber = (unit: Unit, filter: Filter): boolean => {
    const key = filter.field.key
    let conditions = filter.conditionsInUrl ? filter.conditionsInUrl.split('/') : []

    const flattenedUnit = { ...unit, ...unit.rowData, ...unit.customColumnValues }
    let fieldValueForUnit = flattenedUnit[key]
    if (fieldValueForUnit === undefined) return true
    if (conditions.length !== 2) return false
    if (
        parseFloat(fieldValueForUnit) >= parseFloat(conditions[0]) &&
        parseFloat(fieldValueForUnit) <= parseFloat(conditions[1])
    )
        return true

    return false
}

const datetoUnixTime = (date) => {
    try {
        return new Date(date).getTime() / 1000
    } catch (e) {
        return null
    }
}

const filterFunctionDate = (unit: Unit, filter: Filter): boolean => {
    const key = filter.field.key
    let conditions = filter.conditionsInUrl ? filter.conditionsInUrl.split('/') : []

    const flattenedUnit = { ...unit, ...unit.rowData, ...unit.customColumnValues }
    let fieldValueForUnit = flattenedUnit[key]

    if (!fieldValueForUnit) return false

    if (conditions.length !== 2) return false

    if (
        datetoUnixTime(fieldValueForUnit) >= parseFloat(conditions[0]) &&
        datetoUnixTime(fieldValueForUnit) <= parseFloat(conditions[1])
    )
        return true

    return false
}

const filterFunctionId = (unit: Unit, filter: Filter): boolean => {
    const key = filter.field.key

    let conditions = conditionsInUrlToArray(filter.conditionsInUrl)
    const flattenedUnit = { ...unit, ...unit.rowData, ...unit.customColumnValues }
    let fieldValueForUnit = flattenedUnit[key]
    if (fieldValueForUnit === undefined) return false

    const check = conditions
        .map((item) => parseInt(item))
        .find((condition) => condition === parseInt(fieldValueForUnit))

    if (check) {
        return true
    }

    return false
}

const filterFunctionString = (unit: Unit, filter: Filter): boolean => {
    const key = filter.field.key
    let conditions = filter.conditionsInUrl
    const flattenedUnit = { ...unit, ...unit.rowData, ...unit.customColumnValues }

    let fieldValueForUnit = flattenedUnit[key]
    if (fieldValueForUnit === undefined) return true

    if (
        typeof fieldValueForUnit === 'string' &&
        fieldValueForUnit.toLowerCase().search(conditions.toLowerCase())
    )
        return true

    if (typeof fieldValueForUnit === 'object') {
        if (Object.values(fieldValueForUnit).length === 0) return false

        for (const value of Object.values(fieldValueForUnit) as string[]) {
            if (value.toLowerCase().search(conditions.toLowerCase()) >= 0) return true
        }
    }

    return false
}
